import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars /* faSearch */ } from '@fortawesome/free-solid-svg-icons';
import { useMediaQuery } from 'react-responsive';

// import TextInput from '../library/inputs/TextInput';
import Breadcrumbs from './Breadcrumbs';
import Avatar from '../library/data-display/Avatar';
import Button from '../library/inputs/Button';
import Tooltip from '../library/utils/Tooltip';
import { useSession } from '../../hooks/use-session';

import type { MouseEventHandler } from 'react';

interface Props {
  isMenuExpanded: boolean;
  toggleIsMenuExpanded: MouseEventHandler<HTMLButtonElement>;
}

const ActionBar = ({ isMenuExpanded, toggleIsMenuExpanded }: Props) => {
  const isMobile = useMediaQuery({ query: '(max-width: 750px)' });

  const { currentUser } = useSession();

  return (
    <div className="action-bar">
      <div className="left-container">
        {!isMenuExpanded &&
          <div className="action-button">
            <Button
              color="gray"
              iconRight={<FontAwesomeIcon icon={faBars} />}
              onClick={toggleIsMenuExpanded}
              tooltip={!isMobile ?
                <Tooltip
                  id="action-bar-menu-toggle"
                  position="bottom"
                  value="Show menu"
                /> :
                undefined
              }
            />
          </div>
        }
        <Breadcrumbs />
        {/* TODO: Add search bar
          <TextInput
            leftIcon={<FontAwesomeIcon icon={faSearch} />}
            placeholder="Search for anything..."
          />
        */}
      </div>
      <div className="right-container">
        <div className="action-button">
          {currentUser && /* TODO: Show a menu on click */
            <Avatar
              showUserTooltip={false}
              size="large"
              userId={currentUser.id}
            />
          }
        </div>
      </div>
    </div>
  );
};

export default ActionBar;
